/**
 * panelAtoms - Persistent panel layout state for the Graph Explorer.
 *
 * Uses `atomWithStorage` from jotai/utils so that panel expand/collapse
 * state and dimensions survive page reloads via localStorage.
 */

import type { WritableAtom } from 'jotai';
import { type RESET, atomWithStorage } from 'jotai/utils';

// ============================================================================
// Constants
// ============================================================================

/** Duration (ms) of panel slide/reveal CSS transitions. */
export const TRANSITION_MS = 300;

// ============================================================================
// Persisted panel atoms (backed by localStorage)
// ============================================================================

export const LeftPanelExpandedAtom: WritableAtom<
	boolean,
	[boolean | typeof RESET | ((prev: boolean) => boolean | typeof RESET)],
	void
> = atomWithStorage('graph-explorer-left-panel-expanded', true);

export const RightPanelExpandedAtom: WritableAtom<
	boolean,
	[boolean | typeof RESET | ((prev: boolean) => boolean | typeof RESET)],
	void
> = atomWithStorage('graph-explorer-right-panel-expanded', true);

// ============================================================================
// Focus mode entry tracking
// ============================================================================
